// App.jsx
import React, { useState, useEffect } from "react";
import Login from "./components/Login/Login";
import QRPage from "./components/QRPage/QRPage";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import SuperadminDashboard from "./components/SuperadminDashboard/SuperadminDashboard";
import ResetPassword from "./components/Login/ResetPassword";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState("user");
  const [environment, setEnvironment] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const [scannedData, setScannedData] = useState([]);

useEffect(() => {
  const token = localStorage.getItem("token");
  const savedRole = localStorage.getItem("role");
  const savedEnvironment = localStorage.getItem("environment");
  const savedCompanyId = localStorage.getItem("companyId");

  if (token && savedRole) {
    setIsLoggedIn(true);
    setRole(savedRole);
    setEnvironment(savedEnvironment || "production");
    setCompanyId(
      savedCompanyId && /^\d+$/.test(savedCompanyId)
        ? Number(savedCompanyId)
        : null
    );
  }
}, []);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setRole("user");
    setScannedData([]); // Reset
  };
const params = new URLSearchParams(window.location.search);

if (
  params.get("reset") === "true" ||
  /\/reset-password\/?$/.test(window.location.pathname)
) {
  return <ResetPassword />;
}
  return (
    <div>
      {isLoggedIn ? (
        <>

{role === "superadmin" &&
environment === "demo" &&
companyId === null ? (
  <SuperadminDashboard onLogout={handleLogout} />
) : role === "superadmin" ? (
  <div>
    <p>Für dieses Superadmin-Konto ist keine Oberfläche eingerichtet.</p>
    <button type="button" onClick={handleLogout}>
      Abmelden
    </button>
  </div>
) : role === "admin" ? (
  <AdminDashboard onLogout={handleLogout} />
) : (
  <QRPage
    scannedData={scannedData}
    setScannedData={setScannedData}
    onLogout={handleLogout}
  />
)}

        </>
      ) : (
<Login
  onLogin={() => {
    const savedRole = localStorage.getItem("role");
    const savedEnvironment = localStorage.getItem("environment");
    const savedCompanyId = localStorage.getItem("companyId");

    setRole(savedRole || "user");
    setEnvironment(savedEnvironment || "production");
    setCompanyId(
      savedCompanyId && /^\d+$/.test(savedCompanyId)
        ? Number(savedCompanyId)
        : null
    );

    setIsLoggedIn(true);
  }}
/>
      )}
    </div>
  );
};

export default App;